import React, { useEffect, useState } from 'react';
import { findIndex, includes, isEmpty, isNaN, isNil } from 'lodash';
import common from '../common/common';
import translateService from '../common/translateService';
import { getCmsAssetsMediaUrl } from '../services/cms/cmsService';
import marketingAndAnalyticsService from '../services/marketingAndAnalytics/marketingAndAnalyticsService';
import countDownHelper from '../help/countdown';
import Button from './Button.jsx';

const HomeBanner = ({ banner, currentBannerIndex, idx }) => {
    const [countDown, setCountDown] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
    });
    const prefix = 'carousel';

    const clickBanner = async ({ linkUrl, title, index }) => {
        await marketingAndAnalyticsService.recordBannerClick({
            linkUrl,
            title,
            index,
        });
        window.location.href = linkUrl;
    };

    const getFullWebpUrl = ({ bannerImage, format, transformToWebP }) => {
        const toWebP = transformToWebP ?? false;
        const index = findIndex(bannerImage.data, (el) => {
            var formats = { large: '_XXL.', medium: '_XL.', small: '_L.' };
            return includes(el.attributes.name, formats[format]);
        });
        if (index >= 0) {
            let url = bannerImage.data[index].attributes.url.replace(
                '/uploads/',
                'webp/'
            );

            url = toWebP
                ? url
                      .replace('.gif', '.webp')
                      .replace('.jpg', '.webp')
                      .replace('.jpeg', '.webp')
                : url;
            return `${getCmsAssetsMediaUrl()}/${url}`;
        }
        return `${common.getSiteUrl()}/content/products/nophoto_br.png`;
    };

    const getFullUrl = ({ bannerImage, format, transformToWebP }) => {
        const toWebP = transformToWebP ?? false;
        const index = findIndex(bannerImage.data, (el) => {
            var formats = { large: '_XXL.', medium: '_XL.', small: '_L.' };
            return includes(el.attributes.name, formats[format]);
        });
        if (index >= 0) {
            let url = bannerImage.data[index].attributes.url.replace(
                '/uploads/',
                ''
            );

            url = toWebP
                ? url
                      .replace('.gif', '.webp')
                      .replace('.jpg', '.webp')
                      .replace('.jpeg', '.webp')
                : url;
            return `${getCmsAssetsMediaUrl()}/${url}`;
        }
        return `${common.getSiteUrl()}/content/products/nophoto_br.png`;
    };

    const getAnimation = (currentBannerIndex, idx) => {
        // Not sure why I need this dynamic set for the animation to work...not worth losing time understanding why for this moment.
        const res =
            currentBannerIndex === idx
                ? `dynamic-text-${idx} slidecenter-ltr`
                : '';
        // const res = `dynamic-text-${idx} slidecenter-ltr`;
        return res;
    };

    const generateHeadline = (headline) => {
        const r = new RegExp(/(\[\[\s*countdown\s*\]\])+/gi);
        const countDownText = countDownHelper.generateCountdownText(countDown);
        return headline.replace(r, countDownText);
    };

    useEffect(() => {
        // const target = new Date('2023-12-24T23:00:00.000Z');
        const countdown = banner.countdown?.data?.attributes;
        const target = new Date(countdown?.countDownTo);
        if (
            !isNil(countdown) &&
            !isNil(countdown.countDownTo) &&
            !isNaN(target.getTime()) &&
            Date.now() < target.getTime()
        ) {
            const interval = setInterval(() => {
                const c = countDownHelper.generateCountdown(target);
                setCountDown(c);
            }, 250);

            return () => clearInterval(interval);
        }
    }, []);

    return banner.buttonPresent ? (
        <div
            className='carousel-item banner-clickable'
            onClick={async (e) => {
                e.preventDefault();
                e.stopPropagation();
                await clickBanner({
                    linkUrl: banner.bannerLink,
                    title: banner.bannerTitle,
                    index: idx,
                });
                return false;
            }}>
            <div
                className='item banner__link'
                href={banner.bannerLink}
                title={banner.bannerTitle}
                aria-label={banner.bannerTitle}>
                <picture>
                    <source
                        media='(min-width: 1080px)'
                        srcSet={getFullWebpUrl({
                            bannerImage: banner.bannerImage,
                            format: 'large',
                            transformToWebP: true,
                        })}
                        type='image/webp'
                    />
                    <source
                        media='(min-width: 768px)'
                        srcSet={getFullWebpUrl({
                            bannerImage: banner.bannerImage,
                            format: 'medium',
                            transformToWebP: true,
                        })}
                        type='image/webp'
                    />
                    <source
                        media='(max-width: 767px)'
                        srcSet={getFullWebpUrl({
                            bannerImage: banner.bannerImage,
                            format: 'small',
                            transformToWebP: true,
                        })}
                        type='image/webp'
                    />
                    <img
                        className='banner__img'
                        src={getFullUrl({
                            bannerImage: banner.bannerImage,
                            format: 'large',
                            transformToWebP: false,
                        })}
                        alt={banner.bannerTitle}
                    />
                </picture>

                <div style={{ position: 'relative' }}>
                    <div>
                        <div
                            className={getAnimation(currentBannerIndex, idx)}
                            dangerouslySetInnerHTML={{
                                __html: `${
                                    !banner.headline
                                        ? ''
                                        : generateHeadline(banner.headline)
                                }`,
                            }}
                        />
                    </div>
                    <div className='banner_footer'>
                        <Button
                            className='button button--primary item banner__link'
                            text={
                                isNil(banner.buttonText) ||
                                isEmpty(banner.buttonText)
                                    ? translateService.get(`${prefix}.shopNow`)
                                    : banner.buttonText
                            }
                            onClick={async () => {
                                await clickBanner({
                                    linkUrl: banner.bannerLink,
                                    title: banner.bannerTitle,
                                    index: idx,
                                });
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    ) : (
        <div className='carousel-item  banner-clickable'>
            <div
                className='item banner__link'
                aria-label={banner.bannerTitle}
                href={banner.bannerLink}
                title={banner.bannerTitle}
                onClick={async (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    await clickBanner({
                        linkUrl: banner.bannerLink,
                        title: banner.bannerTitle,
                        index: idx,
                    });
                    return false;
                }}>
                <picture>
                    <source
                        media='(min-width: 1080px)'
                        srcSet={getFullWebpUrl({
                            bannerImage: banner.bannerImage,
                            format: 'large',
                            transformToWebP: true,
                        })}
                        type='image/webp'
                    />
                    <source
                        media='(min-width: 768px)'
                        srcSet={getFullWebpUrl({
                            bannerImage: banner.bannerImage,
                            format: 'medium',
                            transformToWebP: true,
                        })}
                        type='image/webp'
                    />
                    <source
                        media='(max-width: 767px)'
                        srcSet={getFullWebpUrl({
                            bannerImage: banner.bannerImage,
                            format: 'small',
                            transformToWebP: true,
                        })}
                        type='image/webp'
                    />
                    <img
                        className='banner__img'
                        src={getFullUrl({
                            bannerImage: banner.bannerImage,
                            format: 'large',
                            transformToWebP: false,
                        })}
                        alt={banner.bannerTitle}
                    />
                </picture>
                <div style={{ position: 'relative' }}>
                    <div>
                        <div
                            className={getAnimation(currentBannerIndex, idx)}
                            dangerouslySetInnerHTML={{
                                __html: `${
                                    !banner.headline
                                        ? ''
                                        : generateHeadline(banner.headline)
                                }`,
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HomeBanner;
